import { ChangeDetectorRef } from '@angular/core'
import { NGXLogger } from 'ngx-logger'
import { OptionsStore, topNamings } from './options-store'

/**
 * contains modal navigation logic and store manipulations
 */
export class ModalOptionsNavigation {


  breakpoints: any
  store: OptionsStore
  logger: NGXLogger
  cdr: ChangeDetectorRef

  constructor(store: OptionsStore, breakpoints: any, logger: NGXLogger, cdr: ChangeDetectorRef) {
    this.store = store
    this.logger = logger
    this.breakpoints = breakpoints
    this.cdr = cdr
  }

  /**
   * used for clear showing state
   */
  setOffAnyState(): void {
    this.store.showMainBlock = false
    this.store.showCoapplicant = false
    this.store.showDecline = false
    this.store.showException = false
    this.store.showPartialApproved = false
    this.store.showDentistSelect = false
    this.cdr.detectChanges()
  }


  /**
   * leads to layout with carousel
   */
   setShowSelectBlock() {
    this.setOffAnyState()
    this.logger.info('Show select block!')
    this.store.topNaming = topNamings.SIMPLE_SEAMLESS
    this.store.showSelectBlock = true
    this.cdr.detectChanges()
  }
  setShowSelectDentistBlock() {
    this.store.showDentistSelect = true
    setTimeout(()=>{
    this.store.showMainBlock = false
    // this.logger.info('Show select block!')
    this.store.topNaming = topNamings.DEFAULT
    this.cdr.detectChanges()
    // this.store.showDentistSelect = true
    },  300)
  }

  /**
   * leads to latest great/good news screen,
   * only after showSelectBlock
   */
  setShowOfferBlock() {
    this.setOffAnyState()
    this.logger.info('Show offer!')
    this.store.topNaming = topNamings.SIMPLE_SEAMLESS
    this.store.showOffer = true
    this.cdr.detectChanges()
  }


  /**
   * leads to layout with why coapplicant
   */
  setShowCoapplicant() {
    this.setOffAnyState()
    this.logger.info('Show coapplicant')
    this.store.topNaming = topNamings.SIMPLE_SEAMLESS
    this.store.showCoapplicant = true
    this.cdr.detectChanges()
  }

  /**
   * leads to layout with why coapplicant
   */
  setShowPartialApproved() {
    this.setOffAnyState()
    this.logger.info('Show partial approved')
    this.store.topNaming = topNamings.SIMPLE_SEAMLESS
    // this.store.showDentistSelect = true
    this.store.showPartialApproved = true
    this.cdr.detectChanges()
  }

  /**
   * leads to straight declined
   */
  setShowDecline() {
    this.setOffAnyState()
    this.logger.info('Show decline!')
    this.store.showDecline = true
    this.cdr.detectChanges()
  }

  /**
   * leads to pending/exception screen
   */
  setShowException() {
    this.setOffAnyState()
    this.logger.info('Show exception!')
    this.store.showException = true
    this.cdr.detectChanges()
  }

  setPartnerDown(){
    this.setOffAnyState()
    this.logger.info('Show Partner Down!')
    this.store.showPartnerDown = true
    this.cdr.detectChanges()
  }

}
